<template>
  <div class="button-dropdown">
    <div
      class="button-dropdown__trigger"
      @click.stop="toggleDropdown"
    >
      <slot name="trigger" />
    </div>
    <div
      v-show="isDropdownVisible"
      class="button-dropdown__dropdown"
    >
      <slot name="items" />
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            isDropdownVisible: false,
            closeDropdownListener: null,
        };
    },
    methods: {
        toggleDropdown() {
            if (this.isDropdownVisible) {
                this.isDropdownVisible = false;
                if (this.closeDropdownListener !== null) {
                    document.body.removeEventListener('click', this.closeDropdownListener);
                    this.closeDropdownListener = null;
                }
            } else {
                this.isDropdownVisible = true;
                if (this.closeDropdownListener !== null) {
                    document.body.removeEventListener('click', this.closeDropdownListener);
                    this.closeDropdownListener = null;
                }
                this.closeDropdownListener = document.body.addEventListener('click', () => {
                    document.body.removeEventListener('click', this.closeDropdownListener);
                    this.closeDropdownListener = null;
                    this.isDropdownVisible = false;
                });
            }
        },
    },
};
</script>

<style lang="stylus">
  .button-dropdown {
    position: relative;
    display: inline-block;
    width: 205px;

    &__button {
      position: relative;
      width: 100%;
    }

    &__caret {
      position: absolute;
      top: 50%;
      right: 4px;
      margin-top: -6px;
    }

    &__dropdown {
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      z-index: 2;
      background: #fff;
      padding: 0px;
      margin-top: 3px;
      border-radius: 5px;
      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    }

     &__item {
       cursor: pointer;
       padding: 10px 10px;
       display: flex;
       align-items: center;
       color: #7C828F;
       min-height: 42px;

       i {
         display: inline-block;
         font-size: 20px;
         width: 20px;
         margin-right: 7px;
       }

       &:hover {
         color: #55ADCD;
       }

       &[disabled] {
         pointer-events: none;
       }
     }

     &__divider {
        padding: 0;
        margin: 3px 0;
        width: 100%;
        height: 1px;
        display: block;
        background: #e3e5eb;
      }
  }
</style>
